class StickyRecentProduct extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.bar = this.closest('.sticky-recent-viewed');
    this.cookieName = this.dataset.cookieName || 'shopify_recently_viewed';
    this.cartUrl = this.dataset.cartUrl || '/cart';

    this.init();
    document.addEventListener('cart-update', this.init.bind(this));
  }

  async init() {
    const cart = await this.fetchCart();
    if (cart && cart.items) {
      cart.items = cart.items.filter((item) => item.sku !== 'Insure01');
    }

    if (cart && cart.items && cart.items.length) {
      this.renderCart(cart);
      this.show();
      return;
    }

    const handle = this.getLastViewedHandle();
    if (!handle || handle == 'awe-shipping-insurance') {
      this.hide();
      return;
    }

    const product = await this.fetchProduct(handle);
    if (!product) {
      this.hide();
      return;
    }

    this.renderViewed(product);
    this.show();
  }

  async fetchCart() {
    try {
      const response = await fetch(`${this.cartUrl}.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return null;
      return response.json();
    } catch (error) {
      return null;
    }
  }

  getLastViewedHandle() {
    let value = this.readCookie(this.cookieName);

    if (!value) {
      try {
        value = localStorage.getItem(this.cookieName);
      } catch (error) {
        value = null;
      }
    }

    if (!value) return '';

    return value.split(' ').map((handle) => handle.trim()).find(Boolean) || '';
  }

  readCookie(name) {
    if (!document.cookie) return null;

    const prefix = `${name}=`;
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.indexOf(prefix) === 0) {
        return decodeURIComponent(cookie.slice(prefix.length));
      }
    }

    return null;
  }

  async fetchProduct(handle) {
    const root = (window.routes && window.routes.root) || '';
    const response = await fetch(`${root}/products/${encodeURIComponent(handle)}.js`);
    if (!response.ok) return null;
    return response.json();
  }

  getItemPrice(item) {
    return Number(item.final_line_price ?? item.line_price ?? item.original_line_price ?? item.price ?? 0);
  }

  getFeaturedCartItem(items) {
    if (!items || !items.length) return null;

    return items.reduce((best, item) => {
      return this.getItemPrice(item) > this.getItemPrice(best) ? item : best;
    });
  }

  renderCart(cart) {
    const item = this.getFeaturedCartItem(cart.items);
    if (!item) {
      this.hide();
      return;
    }

    const count = cart.items.reduce((sum, cartItem) => sum + (cartItem.quantity || 0), 0);
    const skuParts = [];

    if (item.sku) skuParts.push(`SKU: ${item.sku}`);
    skuParts.push(`Qty: ${item.quantity}`);

    this.setMode('cart');

    this.setText('[data-cta-label]', this.dataset.cartButton);
    this.setText('[data-count]', String(count));
    this.setText('[data-product-title]', item.product_title || item.title || '');
    this.setText('[data-product-meta]', skuParts.join(' | '));
    this.setImage(item.image || (item.featured_image && item.featured_image.url), item.product_title || item.title || '');
    this.setLink('[data-product-link]', this.cartUrl);
    this.setLink('[data-cta-link]', this.cartUrl);
  }

  renderViewed(product) {
    const variant = (product.variants && product.variants[0]) || {};

    this.setMode('viewed');
    this.setText('[data-heading-product]', product.title || '');
    this.setText('[data-cta-label]', this.dataset.viewedButton);
    this.setText('[data-count]', '1');
    this.setText('[data-product-title]', product.title || '');
    this.setText('[data-product-meta]', variant.sku ? `SKU: ${variant.sku}` : '');
    this.setImage(product.featured_image, product.title || '');

    const url = product.url || `/products/${product.handle}`;
    this.setLink('[data-product-link]', url);
    this.setLink('[data-cta-link]', url);
  }

  setMode(mode) {
    this.dataset.mode = mode;
    if (this.bar) this.bar.dataset.mode = mode;
  }

  setText(selector, value) {
    const el = this.querySelector(selector);
    if (!el) return;
    el.textContent = value || '';
    if (selector === '[data-product-meta]') el.hidden = !value;
  }

  setImage(url, alt) {
    const image = this.querySelector('[data-product-image]');
    if (!image) return;

    const src = this.sizedImage(url, 160);
    image.src = src;
    image.alt = alt;
    image.hidden = !src;
  }

  setLink(selector, url) {
    const el = this.querySelector(selector);
    if (el) el.href = url || '#';
  }

  sizedImage(url, width) {
    if (!url) return '';
    const separator = url.indexOf('?') === -1 ? '?' : '&';
    return `${url}${separator}width=${width}`;
  }

  show() {
    if (!this.bar) return;

    this.bar.hidden = false;
    requestAnimationFrame(() => {
      this.bar.classList.add('is-visible');
    });
    document.body.classList.add('has-sticky-recent-viewed');
  }

  hide() {
    if (!this.bar) return;

    this.bar.hidden = true;
    this.bar.classList.remove('is-visible');
    document.body.classList.remove('has-sticky-recent-viewed');
  }
}

if (!customElements.get('sticky-recent-product')) {
  customElements.define('sticky-recent-product', StickyRecentProduct);
}
